"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_1251_20",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "2",
  width: "12",
  height: "12",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7038 2.2896c.3923.3886.3953 1.0218.0066 1.4142L9.4076 8.0475l4.2088 4.2487c.3887.3924.3857 1.0256-.0067 1.4142-.3924.3887-1.0255.3857-1.4142-.0066L8 9.4684l-4.1955 4.2354c-.3887.3923-1.0218.3953-1.4142.0066-.3924-.3886-.3954-1.0218-.0067-1.4142l4.2088-4.2487-4.3028-4.3437c-.3887-.3924-.3857-1.0256.0066-1.4142.3924-.3887 1.0256-.3857 1.4142.0066L8 6.6265l4.2896-4.3303c.3886-.3923 1.0218-.3953 1.4142-.0066Z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1251_20)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))], 'IconCloseOutlineIcon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconCloseOutline';
var _default = SvgIcon;
exports["default"] = _default;